import { createGetDownloadPath } from "~/utils/api/reportUtils";

export const getDownloadPath = createGetDownloadPath(
	"/api/deals/:deal_id/deal_completion_reports"
);
